import { NumericFormat } from 'react-number-format';
import { startValueIcon } from './icons';
import classnames from 'classnames';
import { DEFAULT_CSS_CLASS } from '@constants';
import './editor.scss';

const {
  i18n: { __ },
  components: {
    PanelRow,
    PanelBody,
    RangeControl,
    ToggleControl,
    ToolbarGroup,
    ToolbarButton,
    Popover,
  },
  blockEditor: {
    useBlockProps,
    useInnerBlocksProps,
    InspectorControls,
    BlockControls,
  },
  element: { useEffect, useState, useRef },
} = wp;

const Edit = ({ attributes, setAttributes }) => {
  const {
    endVal,
    duration,
    decimalPlaces,
    disableCounting,
    displayThousandSeparator,
    startVal,
  } = attributes;

  const defaultBlockCssClass = DEFAULT_CSS_CLASS.COUNTER;
  const blockProps = useBlockProps({
    className: classnames({ [`${defaultBlockCssClass}__cw`]: true }),
  });
  const innerBlocksProps = useInnerBlocksProps(blockProps);

  const [isEditingStartVal, setIsEditingStartVal] = useState(false);

  const startEditing = (event) => {
    event.preventDefault();
    setIsEditingStartVal(true);
  };

  const stopEditing = () => {
    setIsEditingStartVal(false);
  };

  const countRef = useRef(null);

  useEffect(() => {
    const countEl = countRef.current;
    const inputs = countEl.querySelector(`.${defaultBlockCssClass}__c`);
    if (inputs) {
      inputs.style.width = '10px';
      inputs.style.width = `${inputs.scrollWidth + 2}px`;
    }
  }, [endVal, displayThousandSeparator, decimalPlaces, defaultBlockCssClass]);
  return (
    <>
      <BlockControls>
        <ToolbarGroup>
          {!isEditingStartVal && (
            <ToolbarButton
              icon={startValueIcon}
              title={__('Start Value', 'b3rg')}
              onClick={startEditing}
            />
          )}
          {isEditingStartVal && (
            <ToolbarButton icon={startValueIcon} onClick={stopEditing} />
          )}
        </ToolbarGroup>
      </BlockControls>

      {isEditingStartVal && (
        <Popover
          placement="bottom-start"
          onClose={() => {
            setIsEditingStartVal(false);
          }}
          variant="toolbar"
        >
          <NumericFormat
            value={startVal}
            thousandSeparator={displayThousandSeparator}
            fixedDecimalScale
            style={{
              margin: '20px',
              borderRadius: 0,
            }}
            decimalScale={decimalPlaces}
            onValueChange={(newVal) => {
              setAttributes({
                startVal: newVal.floatValue,
              });
            }}
            placeholder="0"
          />
        </Popover>
      )}

      <InspectorControls>
        <PanelBody>
          <PanelRow>
            <ToggleControl
              label={__('Disable Counting', 'b3rg')}
              onChange={(newVal) => setAttributes({ disableCounting: newVal })}
              checked={disableCounting}
            />
          </PanelRow>
          <PanelRow>
            <label htmlFor="Start Value">Start Value</label>
          </PanelRow>
          <PanelRow>
            <NumericFormat
              value={startVal || 0}
              thousandSeparator={displayThousandSeparator}
              fixedDecimalScale
              decimalScale={decimalPlaces}
              onValueChange={(newVal) => {
                setAttributes({
                  startVal: newVal.floatValue,
                });
              }}
              placeholder="0"
            />
          </PanelRow>
          <PanelRow>
            <RangeControl
              label={__('Duration', 'b3rg')}
              help={__('Animation duration in seconds.', 'b3rg')}
              value={duration}
              onChange={(newVal) => setAttributes({ duration: newVal })}
              min={2}
              max={15}
            />
          </PanelRow>

          <PanelRow>
            <RangeControl
              label={__('Decimal places', 'b3rg')}
              help={__('Amount of decimals to display', 'b3rg')}
              value={decimalPlaces}
              onChange={(newVal) => setAttributes({ decimalPlaces: newVal })}
              min={0}
              max={4}
            />
          </PanelRow>
          <PanelRow>
            <ToggleControl
              label={__('Thousand Separator', 'b3rg')}
              onChange={(newVal) =>
                setAttributes({
                  displayThousandSeparator: newVal,
                })
              }
              checked={displayThousandSeparator}
            />
          </PanelRow>
        </PanelBody>
      </InspectorControls>
      <div {...innerBlocksProps}>
        <div ref={countRef}>
          <NumericFormat
            value={endVal}
            thousandSeparator={displayThousandSeparator}
            fixedDecimalScale
            decimalScale={decimalPlaces}
            onValueChange={(newVal) => {
              setAttributes({
                endVal: newVal.value !== '' ? newVal.floatValue : 0,
              });
            }}
            placeholder="0"
            className={`${defaultBlockCssClass}__c`}
          />
        </div>
      </div>
    </>
  );
};

export default Edit;
